import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getNoPagination } from "actions/tag/actions";
import tagTypes from "data/tag-types";
import filterTypes from "data/filter-types";
import SearchSelect from "views/lib/components/SearchSelect";

class ModalUpdate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            bike: this.props.bike
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.props.getTags([{
            fieldName: "type",
            fieldValue: tagTypes.bike,
            searchOperation: filterTypes.EQUALS.value
        }]);
    }

    handleChange = (ev) => {
        const { name, value } = ev.target;
        const { bike } = this.state;
        if (["phone", "serial"].indexOf(name) > -1) {
            if (!bike.sim) {
                bike.sim = {};
            }
            bike.sim[name] = value;
        } else {
            bike[name] = value;
        }
        this.setState({
            bike
        });
    };

    handleSubmit = () => {
        this.props.onSubmit(this.state.bike);
    };

    render() {
        const { tags } = this.props;
        const { bike } = this.state;

        return (
            <div>
                <div className="form-group">
                    <label>QR Code</label>
                    <input
                        className="form-control form-control-sm"
                        type="text"
                        value={bike.qr || ""}
                        name="qr"
                        onChange={this.handleChange}
                    />
                </div>
                <div className="form-group">
                    <label>SIM Phone</label>
                    <input
                        className="form-control form-control-sm"
                        type="text"
                        value={bike.sim ? bike.sim.phone : ""}
                        name="phone"
                        onChange={this.handleChange}
                    />
                </div>
                <div className="form-group">
                    <label>SIM Serial</label>
                    <input
                        className="form-control form-control-sm"
                        type="text"
                        value={bike.sim ? bike.sim.serial : ""}
                        name="serial"
                        onChange={this.handleChange}
                    />
                </div>
                <div>
                    <label>Tags</label>
                    <SearchSelect
                        className="search-select"
                        isLoading={false}
                        onChange={options => {
                            const { bike } = this.state;
                            bike.tags = options
                                ? options.map(item => item.value)
                                : null;
                            this.setState({
                                bike
                            });
                        }}
                        options={tags.map(value => ({
                            label: value.name,
                            value: value.name
                        }))}
                        value={bike.tags
                            ? bike.tags.map(item => ({
                                label: item,
                                value: item
                            })) : null}
                        isMulti={true}
                    />
                </div>
                <div className="text-right mt-2">
                    <button
                        className="btn btn-danger mr-2"
                        onClick={this.props.onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-success"
                        onClick={this.handleSubmit}
                    >
                        Save
                    </button>
                </div>
            </div>
        );
    }
}

ModalUpdate.propTypes = {
    bike: PropTypes.object.isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    tags: state.tag.tagListNoPagination,
});

const mapStateToDispatch = dispatch => ({
    getTags: bindActionCreators(getNoPagination, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(ModalUpdate);



// WEBPACK FOOTER //
// ./src/views/pages/bikes/modal-update.js